import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class CommonDataService {
  public dataSource = new Subject<any>();
  public dataSourceSub = new Subject<any>();
  public loaderStatus = new Subject<boolean>();

  constructor(private http: HttpClient) { }

  setBreadCrumbs = (data: string, breadCrmb = null) => {
    if (data) {
      const paths = [];
      paths.push({ breadCrumb: 'Home', url: 'home' });
      paths.push(data);
      if (breadCrmb) {
        paths.push(breadCrmb);
      }
      this.dataSource.next(paths);
    } else {
      this.dataSource.next('');
    }
  }

  setSubBreadCrumb = (val: any) => {
    this.dataSourceSub.next(val);
  }

  setLoader = (val: boolean) => {
    this.loaderStatus.next(val);
  }

  convertToString = (obj: any) => {
    return _.cloneDeepWith(obj, (value: any) => {
      return !_.isPlainObject(value) ? _.toString(value) : undefined;
    });
  }

  customDate = (value: string | number | Date) => {
    const month = new Array();
    const parseDate = new Date(value);
    let suffix = 'th';
    const day = parseDate.getDate().toString();
    month[0] = 'January';
    month[1] = 'February';
    month[2] = 'March';
    month[3] = 'April';
    month[4] = 'May';
    month[5] = 'June';
    month[6] = 'July';
    month[7] = 'August';
    month[8] = 'September';
    month[9] = 'October';
    month[10] = 'November';
    month[11] = 'December';

    if (day === '1' || day === '21' || day === '31') {
      suffix = 'st';
    } else if (day === '2' || day === '22') {
      suffix = 'nd';
    } else if (day === '3' || day === '23') {
      suffix = 'rd';
    }
    return day + suffix + ' ' + month[parseDate.getMonth()] + ' ' + parseDate.getFullYear();
  }
}
